export default __webpack_public_path__ + "static/media/3182.99bc8326.png";